import { LiveLinkService } from './../../../../services/live-link/live-link.service';
import { Component, Input } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'public-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @Input()content !: HTMLDivElement;
  menuOpen = false;
  navTransparent: boolean = false;
  scrollThreshold: number = 240;
  inHomePage: boolean = false;
  hasLive: boolean = false;
  liveUrl: string = ''

  constructor(
    private router: Router,
    private liveLinkService: LiveLinkService
  ){}

  ngOnInit() {
    this.inHomePage = this.router.url === '/';

    this.router.events.subscribe((event) => {
      if(event instanceof NavigationEnd){
        this.inHomePage = event.url === '/';
        this.menuOpen = false;
      }
    });

    this.liveLinkService.getLink().subscribe({
      next: (value) => {
        this.liveUrl = value.url
        this.hasLive = value.is_live
      },
    });

    this.checkScrollPosition();
  }

  ngAfterViewInit() {
    if (this.content) {
      this.content.addEventListener('scroll', this.onContentScroll.bind(this));
      this.checkScrollPosition();
    }
  }

  onContentScroll() {
    this.checkScrollPosition();
  }

  checkScrollPosition() {
    const currentScroll = this.content.scrollTop || 0;
    this.navTransparent = currentScroll <= this.scrollThreshold;
  }
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
}
